import { render, staticRenderFns } from "./KListWithOverflow.vue?vue&type=template&id=6fe3b37a&scoped=true"
import script from "./KListWithOverflow.vue?vue&type=script&lang=js"
export * from "./KListWithOverflow.vue?vue&type=script&lang=js"
import style0 from "./KListWithOverflow.vue?vue&type=style&index=0&id=6fe3b37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe3b37a",
  null
  
)

export default component.exports